import React from 'react';

/**
 * EmberParticles - Floating ember/spark particles for atmosphere
 * Enhanced with more realistic fire embers that rise from the bottom
 */
export default function EmberParticles({ count = 30, intensity = 1 }) {
  // Generate random particles
  const particles = React.useMemo(() => {
    return [...Array(count)].map((_, i) => ({
      id: i,
      size: 4 + Math.random() * 5,
      left: Math.random() * 100,
      duration: 7 + Math.random() * 7,
      delay: Math.random() * 8,
      opacity: (0.4 + Math.random() * 0.4) * intensity,
    }));
  }, [count, intensity]);

  return (
    <div className="fixed inset-0 overflow-hidden pointer-events-none z-0">
      {particles.map((particle) => (
        <div
          key={particle.id}
          className="absolute rounded-full ember-particle"
          style={{
            width: `${particle.size}px`,
            height: `${particle.size}px`,
            background: 'radial-gradient(circle, #ffd45a, #ff7b00 70%, transparent 71%)',
            filter: 'blur(0.2px)',
            left: `${particle.left}%`,
            bottom: '-20px',
            animation: `ember-rise-enhanced ${particle.duration}s linear infinite`,
            animationDelay: `${particle.delay}s`,
            opacity: 0,
          }}
        />
      ))}
      
      {/* CSS Animation */}
      <style>{`
        @keyframes ember-rise-enhanced {
          0% {
            transform: translateY(0) scale(1);
            opacity: 0;
          }
          10% {
            opacity: 0.55;
          }
          100% {
            transform: translateY(-120vh) scale(0.45);
            opacity: 0;
          }
        }
      `}</style>
    </div>
  );
}
